import(/* webpackMode: "eager" */ "/build/apps/web/src/app/error.tsx");
